// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"FullPizza","810":"NotFound","965":"Cart"}[chunkId] || chunkId) + "." + {"102":"31d6695e","332":"7229af08","810":"d027cc29","965":"6d6f61b0"}[chunkId] + ".chunk.js";
};